import { z } from 'zod'

export const oauthProviderSchema = z.enum(['kakao', 'apple', 'line', 'google']).optional().default('kakao')
export const authSessionProviderSchema = z
  .enum(['kakao', 'apple', 'line', 'google', 'skillflo'])
  .optional()
  .default('kakao')
